import { Box, Typography } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  email: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis'
  }
});


export const UserNameCell: React.FC<{ value?: string }> = ({ value }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="body2" color="textPrimary" className={classes.name}>{value}</Typography>
    </Box>
  );
};
